import { createRoute, lazyRouteComponent } from "@tanstack/react-router"
import { webappRoute } from "./layout"

interface AdvisorInnerSearch {
  advisorId?: string
}

const LazyAdvisorInnerPage = lazyRouteComponent(() => import("./lazy-pages"), "AdvisorInnerPage")

export const advisorInnerRoute = createRoute({
  getParentRoute: () => webappRoute,
  path: "/advisors/inner",
  validateSearch: (raw: Record<string, unknown>): AdvisorInnerSearch => ({
    advisorId: typeof raw.advisorId === "string" ? raw.advisorId : undefined,
  }),
  component: AdvisorInnerComponent,
})

function AdvisorInnerComponent() {
  const { advisorId } = advisorInnerRoute.useSearch()
  return <LazyAdvisorInnerPage advisorId={advisorId} />
}
